import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';
import axios from '@/config/axios';

export default {
  name: 'BookOldBooks',
  components: { Header, Footer },
  data() {
    return {
      idBook: '',
      catalogBook: null,
      catalogCoverError: false,
      booths: [],
      isLoading: false,
      currentPage: 0,
      totalPages: 0,
      totalElements: 0,
      selectedSort: 'default'
    };
  },
  computed: {
    catalogAuthorsStr() {
      if (!this.catalogBook) return '';
      if (this.catalogBook.authors && Array.isArray(this.catalogBook.authors)) {
        return this.catalogBook.authors.map(a => a.name).filter(Boolean).join(', ');
      }
      return this.catalogBook.author || '';
    },
    catalogCategoriesStr() {
      if (!this.catalogBook) return '';
      if (this.catalogBook.categories && Array.isArray(this.catalogBook.categories)) {
        return this.catalogBook.categories.map(c => c.name).filter(Boolean).join(', ');
      }
      return '';
    },
    sortedBooths() {
      if (!this.booths || !Array.isArray(this.booths)) return [];
      const list = [...this.booths];
      if (this.selectedSort === 'price_asc') {
        return list.sort((a, b) => (a.price || 0) - (b.price || 0));
      }
      if (this.selectedSort === 'price_desc') {
        return list.sort((a, b) => (b.price || 0) - (a.price || 0));
      }
      return list;
    }
  },
  watch: {
    '$route.params.idBook': {
      handler(newId) {
        if (newId) {
          this.idBook = newId;
          this.initPage();
        }
      },
      immediate: true
    }
  },
  methods: {
    async initPage() {
      await this.fetchCatalogBook();
      this.fetchBooths(0);
    },
    fetchCatalogBook() {
      if (!this.idBook) return Promise.resolve();
      this.catalogCoverError = false;
      return axios.get(`book/v1/detail/${this.idBook}`)
        .then(res => {
          if (res.data.status === '200' && res.data.result) {
            const bookData = res.data.result;
            if (bookData.cover && !(bookData.cover.startsWith('data:') || bookData.cover.startsWith('http'))) {
              bookData.cover = 'data:image/png;base64,' + bookData.cover;
            }
            this.catalogBook = bookData;
          }
        })
        .catch(err => {
          console.error("Failed to load catalog book details", err);
        });
    },
    fetchBooths(page) {
      if (!this.idBook) return;
      this.isLoading = true;
      axios.get('old-book/v1/search', { params: { page, idBook: this.idBook } })
        .then(res => {
          if (res.data.status === '200' && res.data.result) {
            const result = res.data.result;
            const items = result.content || [];
            this.booths = items.map(item => {
              ['stackImage', 'coverImage'].forEach(k => {
                if (item[k] && typeof item[k] === 'string' && !item[k].startsWith('data:') && !item[k].startsWith('http')) {
                  item[k] = 'data:image/png;base64,' + item[k];
                }
              });
              if (item.books && Array.isArray(item.books)) {
                item.books.forEach(b => {
                  ['cover', 'coverBack'].forEach(k => {
                    if (b[k] && typeof b[k] === 'string' && !b[k].startsWith('data:') && !b[k].startsWith('http')) {
                      b[k] = 'data:image/png;base64,' + b[k];
                    }
                  });
                });
              }
              return item;
            });
            this.currentPage = page;
            this.totalPages = result.totalPages || 0;
            this.totalElements = result.totalElements || 0;
          } else {
            this.booths = [];
            this.totalElements = 0;
          }
        })
        .catch(err => {
          console.error("Failed to load booths by idBook", err);
          this.booths = [];
          this.totalElements = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    goToDetail(id) {
      if (id) {
        this.$router.push('/old-books/' + id);
      }
    },
    getCoverUrl(path) {
      const placeholder = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      if (!path || typeof path !== 'string') return placeholder;
      if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:') || path.startsWith('blob:')) return path;
      if (!path.includes('/') && !path.includes('\\') && !path.includes(':')) return 'data:image/jpeg;base64,' + path;
      let cleanPath = path.replace(/\\/g, '/');
      if (cleanPath.includes('oldbooks/')) cleanPath = cleanPath.substring(cleanPath.indexOf('oldbooks/'));
      else if (cleanPath.includes('cover/')) cleanPath = cleanPath.substring(cleanPath.indexOf('cover/'));
      else if (cleanPath.includes('storge/')) cleanPath = cleanPath.substring(cleanPath.indexOf('storge/'));
      cleanPath = cleanPath.replace(/^[A-Za-z]:/, '').replace(/^\/+/, '');
      const apiServiceUrl = process.env.VUE_APP_API_SERVICE_URL || process.env.VUE_APP_API_URL || '';
      const apiHost = apiServiceUrl.replace(/\/api\/?$/, '').replace(/\/+$/, '');
      return apiHost ? `${apiHost}/${cleanPath}` : `/${cleanPath}`;
    },
    handleImageError(event) {
      if (event && event.target) {
        event.target.onerror = null;
        event.target.src = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      }
    },
    formatPrice(price) {
      if (!price && price !== 0) return 'Liên hệ';
      return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
    },
    getListingStatusLabel(status) {
      const statuses = {
        0: 'Đang bán',
        1: 'Đã cọc',
        2: 'Đã bán',
        3: 'Tạm ngưng',
        4: 'Hủy bài'
      };
      return statuses[status] !== undefined ? statuses[status] : 'Đang bán';
    },
    getAuthorsList(booth) {
      if (!booth) return [];
      if (booth.authorsSummary && Array.isArray(booth.authorsSummary) && booth.authorsSummary.length > 0) {
        return booth.authorsSummary;
      }
      if (booth.books && Array.isArray(booth.books)) {
        const names = [];
        booth.books.forEach(b => {
          if (b.author && b.author.trim() && !names.includes(b.author.trim())) {
            names.push(b.author.trim());
          }
        });
        return names;
      }
      return [];
    }
  }
};
